import { queryOptions } from "@tanstack/react-query";
import {
  getBankCodes,
  payCancel,
  payInfo,
  tournamentPayInfo,
} from "../v1/payment.service";
import type { CancelRequest } from "../dto/request/payment.request";

// 은행 코드 목록 (환불 계좌 은행 선택 등)
export const useBankCodes = () =>
  queryOptions({
    queryKey: ["bank-codes"],
    queryFn: () => getBankCodes(),
    staleTime: 1000 * 60 * 60,
  });

export const usePayInfo = (id: string | number) => queryOptions({
    queryKey: ["pay-info", id],
    queryFn: () => payInfo(id),
    retry: 1
})

// 예약 취소 시 취소금 조회
export const usePayCancel = (form: CancelRequest) => queryOptions({
    queryKey: ["pay-cancel", form],
    queryFn: () => payCancel(form),
    retry: 1
})

export const useTournamentPayInfo = (id: string | number) => queryOptions({
    queryKey: ["tournament-pay-info", id],
    queryFn: () => tournamentPayInfo(id),
    retry: 1
})